import { render } from "./BlogMassiveProductDB.vue?vue&type=template&id=7dcdc64d"
import script from "./BlogMassiveProductDB.vue?vue&type=script&lang=js"
export * from "./BlogMassiveProductDB.vue?vue&type=script&lang=js"

import "./BlogMassiveProductDB.vue?vue&type=style&index=0&id=7dcdc64d&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__